import React from 'react';
import { fetchDataWithQuery } from '../meal-details/fetchData';
import mealPageQuery from './mealPageQuery.graphql';
import MealPage, { type MealPageData } from './MealPage';

/**
 * Screen module for the rebuilt meal page (W3.1). With ENABLE_NEW_DETAIL_PAGES
 * on, the router and the MealDetailsScreen entry load this instead of
 * screens/meal-details, which stays untouched. Same fetch (slug parsing, 404,
 * error mapping) with the additive query.
 */
export const fetchData = fetchDataWithQuery(mealPageQuery);

export const MealDetails = ({
    data,
    location,
    error,
}: {
    data: MealPageData | null | undefined;
    location?: { pathname?: string };
    error?: { message?: string } | null;
}) => <MealPage data={data} location={location} error={error} />;
